// @ts-strict-ignore
/* eslint-disable camelcase */
import fetch from "@lib/fetch";
import { userInfoSegmentsCacheKey } from "./constants";
import type { UserInfoSegmentsOptions, UserInfoSegmentsResponse } from "./types";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

/**
 * Fetch segments that a user is a member of, by user id
 *
 * @param user_identifier unique identifier for user
 * @returns array containing segments for user, if any
 */
export const getUserInfoSegmentsByIdentifier = reactQueryFetcherAdapter(
  userInfoSegmentsCacheKey,
  async (signal, userIdentifier: string, opts: UserInfoSegmentsOptions = {}): Promise<UserInfoSegmentsResponse> => {
    return fetch(`/apps/user_info_segments/${encodeURIComponent(userIdentifier)}`, "GET", opts, { signal });
  }
);
